import type { SVGProps } from 'react';
const SvgAmpStories = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#amp_stories_svg__a)">
      <path d="M17 4H7v15h10V4ZM5 6H3v11h2V6ZM21 6h-2v11h2V6Z" />
    </g>
    <defs>
      <clipPath id="amp_stories_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAmpStories;
